import { useEffect } from 'react';

// Titre de marque par défaut — identique au <title> de index.html (repli
// quand un écran n'a pas de nom propre à afficher dans l'onglet).
export const DEFAULT_DOCUMENT_TITLE = 'Rabbit Prompt — Stop typing. Start designing.';

/**
 * Pose document.title à chaque changement de `title` ; un titre vide ou
 * absent retombe sur la marque. Pas de restauration à l'unmount : l'écran
 * suivant pose son propre titre (DocumentTitleSync couvre les routes).
 */
export const useDocumentTitle = (title?: string | null): void => {
  useEffect(() => {
    document.title = title && title.trim() ? title : DEFAULT_DOCUMENT_TITLE;
  }, [title]);
};

export default useDocumentTitle;
